import React, { useState, useEffect, useCallback } from 'react';
import { Card } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { RefreshCw, Loader2, Rocket } from 'lucide-react';
import { adminApi } from '../../lib/api';
import { DeployLog } from '../../types/titan';



const DeploysTab: React.FC = () => {
  const [deploys, setDeploys] = useState<DeployLog[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchDeploys = useCallback(async () => {
    setLoading(true);
    try {
      const data = await adminApi.deploys(50);
      setDeploys(data.deployments || []);
    } catch (e) {
      console.error('Failed to fetch deploys:', e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchDeploys(); }, [fetchDeploys]);

  if (loading) return <div className="flex items-center justify-center py-12"><Loader2 className="w-6 h-6 animate-spin text-muted-foreground" /></div>;

  if (deploys.length === 0) {
    return (
      <div className="text-center py-12 text-muted-foreground">
        <Rocket className="w-10 h-10 mx-auto mb-3 opacity-40" />
        <p className="text-sm">No deployments logged yet</p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <p className="text-sm text-muted-foreground">{deploys.length} deployment{deploys.length !== 1 ? 's' : ''}</p>
        <Button variant="outline" size="sm" onClick={fetchDeploys}><RefreshCw className="w-4 h-4 mr-1" /> Refresh</Button>
      </div>

      {deploys.map((d, i) => (
        <Card key={i} className="p-4">
          <div className="flex items-start justify-between">
            <div>
              <div className="flex items-center gap-2">
                <span className="font-semibold text-sm">{d.version}</span>
                <Badge variant={d.environment === 'production' ? 'default' : 'secondary'} className="text-[10px]">{d.environment}</Badge>
              </div>
              {d.notes && <p className="text-sm text-muted-foreground mt-1">{d.notes}</p>}
            </div>
            <div className="text-right flex-shrink-0">
              <p className="text-xs text-muted-foreground">{d.deployed_at ? new Date(d.deployed_at).toLocaleDateString() : ''}</p>
              <p className="text-[11px] text-muted-foreground">{d.deployed_by}</p>
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
};

export default DeploysTab;
